import React, { useEffect, useState } from 'react';

import FaqCategories from './FaqCategories/';
import FaqSearch from './FaqSearch/';
import PropTypes from 'prop-types';

const Faq = ({defaultCategory, faqCategory, categoriesList, postsByTerm, portal}) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.search));

  useEffect(() => {
    const handleUrlChange = () => {
      setSearchParams(new URLSearchParams(window.location.search)); // Update state
    };

    window.addEventListener("popstate", handleUrlChange);

    const originalPushState = history.pushState;
    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      handleUrlChange();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      handleUrlChange();
    };

    return () => {
      window.removeEventListener("popstate", handleUrlChange);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, []);

  useEffect(() => {
    const searchTerm = searchParams.get("search");

    if (searchTerm) {
      setShowSearch(true);
    } else {
      setShowSearch(false);
    }
  }, [searchParams]);

  return (
    <>
      <FaqSearch isSearch={showSearch} />

      {!showSearch ? (
        <FaqCategories
          isSearch={showSearch}
          defaultCategory={defaultCategory}
          faqCategory={faqCategory}
          categoriesList={categoriesList}
          postsByTerm={postsByTerm}
          portal={portal}
        />
    ) : null }
    </>
  )
}

Faq.propTypes = {
  defaultCategory: PropTypes.object,
  faqCategory: PropTypes.string,
  postsByTerm: PropTypes.object,
  filter: PropTypes.string,
};

Faq.defaultProps = {
  defaultCategory: {},
  faqCategory: '',
  categoriesList: [],
  postsByTerm: {},
  filter: '',
};



export default Faq;

